import APIModel from "../../Models/APIModel";
import axios from "axios";

export const getUsers = (token) => {
	return axios.get(APIModel.HOST + "User/GetAllUsers", {
		'headers': {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'token': token
		}
	});
};

export const createUser = (token, params) => {
	return axios.post(APIModel.HOST + "User/CreateUser", params, {
		'headers': {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'token': token
		}
	});
};

export const editUser = (token, params) => {
	return axios.post(APIModel.HOST + "User/EditUser", params, {
		'headers': {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'token': token
		}
	});
};

export const changePassword = (token, params) => {
	return axios.post(APIModel.HOST + "Admin/UpdatePassword", params, {
		'headers': {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'token': token
		}
	});
};

export const getGates = (token) => {
	return axios.get(APIModel.HOST + "Admin/GetAllGates", {
		'headers': {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'token': token
		}
	});
};
